import { motion } from 'motion/react';
import { Plus } from 'lucide-react';

interface DockAddButtonProps {
  onClick: () => void;
  isMobile: boolean;
}

export function DockAddButton({ onClick, isMobile }: DockAddButtonProps) {
  const size = isMobile ? 72 : 80;

  return (
    <motion.button
      className="flex flex-shrink-0 flex-col items-center gap-1"
      style={{ width: isMobile ? 82 : 90 }}
      onClick={onClick}
      whileTap={{ scale: 0.95 }}
      initial={{ opacity: 0, scale: 0.8 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ type: 'spring', stiffness: 400, damping: 25 }}
    >
      <div
        className="flex items-center justify-center border-2 border-dashed border-white/40 bg-white/20 backdrop-blur-md"
        style={{ width: size, height: size, borderRadius: '50%' }}
      >
        <Plus size={isMobile ? 28 : 32} className="text-gray-400" strokeWidth={1.8} />
      </div>
    </motion.button>
  );
}
